import { useMutation } from '@tanstack/react-query'
import { createApiCall } from 'services'

export type ChangeEmailPayload = {
  newEmail: string
}

export type ChangeEmailResponse = {
  success: boolean
  pending_email: string
  message: string
}

type ChangeEmailApiError = Error & {
  status?: number
}

const toMutationError = (status: number, fallbackMessage: string, message?: string): ChangeEmailApiError => {
  const error = new Error(message || fallbackMessage) as ChangeEmailApiError
  error.status = status
  return error
}

export const useChangeEmailMutation = () => {
  const mutation = useMutation<ChangeEmailResponse, ChangeEmailApiError, ChangeEmailPayload>({
    mutationFn: async payload => {
      const response = await createApiCall({
        method: 'PUT',
        url: '/auth/admin/email',
        data: payload,
      })

      if (response.status !== 200) {
        throw toMutationError(
          response.status,
          'Failed to change email',
          typeof response.data?.message === 'string' ? response.data.message : undefined
        )
      }

      return response.data as ChangeEmailResponse
    },
  })

  return {
    changeEmail: mutation.mutate,
    changeEmailAsync: mutation.mutateAsync,
    isChangingEmail: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  }
}
